export const manufacturingCards = {
    machineCard: {
        entity: 'machine',
        path: 'machine',
        titleBar: { mergeParams: ['name'], new: 'manufacturing.machine.form.new.title' },
        cardTitle: {
            title: 'manufacturing.machine.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.machine.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'machine',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'nameCode',
                        fields: [
                            {
                                type: 'text',
                                id: 'name',
                                label: 'manufacturing.machine.form.name',
                                placeholder: 'manufacturing.machine.form.name.placeholder',
                                required: true
                            },
                            {
                                type: 'code',
                                id: 'code',
                                label: 'manufacturing.machine.form.code',
                                placeholder: 'manufacturing.machine.form.code.placeholder',
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'workCenterId',
                        displayField: 'workCenterName',
                        label: 'manufacturing.machine.form.workCenter',
                        placeholder: 'manufacturing.machine.form.workCenter.placeholder',
                        modalTitle: 'manufacturing.machine.form.workCenter.modal.title',
                        entity: 'workCenter',
                        valueMap: {
                            'workCenterName': 'name',
                            'workCenterId': 'id'
                        },
                        options: { withHeaders: false }
                    },
                    {
                        type: 'switchSelect',
                        id: 'status',
                        displayField: 'statusName',
                        label: 'manufacturing.machine.form.status',
                        entity: 'machineStatus',
                        valueMap: {
                            'status': 'id',
                            'statusName': 'name'
                        },
                    },
                    {
                        type: 'group',
                        id: 'lastNextMaintenanceDate',
                        fields: [
                            {
                                type: 'date',
                                id: 'lastMaintenanceDate',
                                label: 'manufacturing.machine.form.lastMaintenance',
                                placeholder: 'manufacturing.machine.form.lastMaintenance.placeholder'
                            },
                            {
                                type: 'date',
                                id: 'nextMaintenanceDate',
                                label: 'manufacturing.machine.form.nextMaintenance',
                                placeholder: 'manufacturing.machine.form.nextMaintenance.placeholder'
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'specifications',
                        label: 'manufacturing.machine.form.specifications',
                        placeholder: 'manufacturing.machine.form.specifications.placeholder',
                        rows: 3
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'manufacturing.machine.form.notes',
                        placeholder: 'manufacturing.machine.form.notes.placeholder',
                        rows: 2
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'machineCard.machine.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '40%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'field', value: 'code', scale: 'normal' },
                                { type: 'field', value: 'statusName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '60%',
                            elements: [
                                { type: 'field', value: 'workCenterName', scale: 'normal' },
                                { type: 'date', value: 'lastMaintenanceDate', scale: 'normal' },
                                { type: 'date', value: 'nextMaintenanceDate', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    machineDowntimeCard: {
        entity: 'machineDowntime',
        path: 'machine/:id/machineDowntime',
        titleBar: { mergeParams: ['reasonName'], new: 'manufacturing.machineDowntime.form.new.title' },
        cardTitle: {
            title: 'manufacturing.machineDowntime.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.machineDowntime.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'machineDowntime',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'switchSelect',
                        id: 'reason',
                        displayField: 'reasonName',
                        label: 'manufacturing.machineDowntime.form.reason',
                        entity: 'downtimeReason',
                        valueMap: {
                            'reason': 'id',
                            'reasonName': 'name'
                        },
                        required: true,
                    },
                    {
                        type: 'group',
                        id: 'startEndTime',
                        fields: [
                            {
                                type: 'date',
                                id: 'startTime',
                                label: 'manufacturing.machineDowntime.form.startTime',
                                required: true,
                                defaultType: 'date'
                            },
                            {
                                type: 'date',
                                id: 'endTime',
                                label: 'manufacturing.machineDowntime.form.endTime'
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'manufacturing.machineDowntime.form.notes',
                        placeholder: 'manufacturing.machineDowntime.form.notes.placeholder',
                        rows: 3
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'machineDowntimeCard.machineDowntime.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'reasonName',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'field', value: 'reasonName', scale: 'title' },
                                { type: 'date', value: 'startTime', scale: 'normal' },
                                { type: 'date', value: 'endTime', scale: 'normal' },
                                { type: 'field', value: 'notes', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    manufacturingSettingsCard: {
        entity: 'manufacturingSettings',
        path: 'manufacturingSettings',
        titleBar: { label: 'manufacturing.settings.heading', mergeParams: ['settingType'], new: 'manufacturing.settings.title' },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            {
                id: 'manufacturingSettings.shifts',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'globalDefaultShift',
                        label: 'manufacturing.settings.shifts.title',
                        text: 'manufacturing.settings.shifts.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'connect',
                        id: 'defaultShiftId',
                        displayField: 'defaultShiftName',
                        label: 'manufacturing.settings.defaultShift',
                        placeholder: 'manufacturing.settings.defaultShift.placeholder',
                        modalTitle: 'manufacturing.settings.defaultShift.modal.title',
                        entity: 'shift',
                        valueMap: {
                            'defaultShiftId': 'id',
                            'defaultShiftName': 'name',
                            'defaultShiftCode': 'code'
                        },
                        options: { withHeaders: true }
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'manufacturingSettingsCard.shifts.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'defaultShiftId',
                    emptyMessage: 'manufacturing.settings.shifts.display.title',
                    columns: [
                        {
                            weight: 3,
                            basis: '30%',
                            elements: [
                                { type: 'text', value: 'manufacturing.settings.shifts.display.title', scale: 'title' }
                            ]
                        },
                        {
                            weight: 7,
                            basis: '70%',
                            align: 'end',
                            elements: [
                                { type: 'text', value: 'manufacturing.settings.defaultShift', scale: 'title' },
                                { type: 'merge', value: '${1}', mergeParams: ['defaultShiftName'], scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    plantCard: {
        entity: 'plant',
        path: 'plant',
        titleBar: { mergeParams: ['name'], new: 'manufacturing.plant.form.new.title' },
        cardTitle: {
            title: 'manufacturing.plant.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.plant.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'plant',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'manufacturing.plant.form.name',
                        placeholder: 'manufacturing.plant.form.name.placeholder',
                        required: true
                    },
                    {
                        type: 'code',
                        id: 'code',
                        label: 'manufacturing.plant.form.code',
                        placeholder: 'manufacturing.plant.form.code.placeholder',
                        required: true
                    },
                    {
                        type: 'connect',
                        id: 'warehouseId',
                        displayField: 'warehouseName',
                        label: 'manufacturing.plant.form.warehouse',
                        placeholder: 'manufacturing.plant.form.warehouse.placeholder',
                        modalTitle: 'manufacturing.plant.form.warehouse.modal.title',
                        entity: 'warehouse',
                        valueMap: {
                            'warehouseId': 'id',
                            'warehouseName': 'name',
                            'warehouseCode': 'code'
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'connect',
                        id: 'shiftId',
                        displayField: 'shiftName',
                        label: 'manufacturing.plant.form.shift',
                        placeholder: 'manufacturing.plant.form.shift.placeholder',
                        modalTitle: 'manufacturing.plant.form.shift.modal.title',
                        entity: 'shift',
                        valueMap: {
                            'shiftId': 'id',
                            'shiftName': 'name',
                            'shiftCode': 'code'
                        },
                        options: { withHeaders: true }
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'plantCard.plant.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '50%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'field', value: 'code', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '50%',
                            elements: [
                                { type: 'field', value: 'warehouseName', scale: 'normal' },
                                { type: 'field', value: 'shiftName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    qualityCheckCard: {
        entity: 'qualityCheck',
        path: 'qualityCheck',
        titleBar: { mergeParams: ['date'], new: 'manufacturing.qualityCheck.form.new.title' },
        cardTitle: {
            title: 'manufacturing.qualityCheck.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.qualityCheck.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'qualityCheck',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'dateResult',
                        fields: [
                            {
                                type: 'date',
                                id: 'date',
                                label: 'manufacturing.qualityCheck.form.date',
                                required: true,
                                defaultType: 'date'
                            },
                            {
                                type: 'switchSelect',
                                id: 'result',
                                displayField: 'resultName',
                                label: 'manufacturing.qualityCheck.form.result',
                                entity: 'qualityResult',
                                valueMap: {
                                    'result': 'id',
                                    'resultName': 'name'
                                },
                                required: true,
                            }
                        ]
                    },
                    {
                        type: 'select',
                        id: 'workOrderId',
                        displayField: 'workOrderNumber',
                        label: 'manufacturing.qualityCheck.form.workOrder',
                        placeholder: 'manufacturing.qualityCheck.form.workOrder.placeholder',
                        entity: 'workOrder',
                        valueMap: {
                            'workOrderNumber': 'number',
                            'workOrderId': 'id'
                        },
                        options: { withHeaders: false, autoSelectFirst: false },
                        defaultType: 'none'
                    },
                    {
                        type: 'connect',
                        id: 'productId',
                        displayField: 'productName',
                        label: 'manufacturing.qualityCheck.form.product',
                        placeholder: 'manufacturing.qualityCheck.form.product.placeholder',
                        modalTitle: 'manufacturing.qualityCheck.form.product.modal.title',
                        entity: 'product',
                        valueMap: {
                            'productName': 'name',
                            'productId': 'id'
                        },
                        options: { withHeaders: false }
                    },
                    {
                        type: 'text',
                        id: 'inspectorName',
                        label: 'manufacturing.qualityCheck.form.inspector',
                        placeholder: 'manufacturing.qualityCheck.form.inspector.placeholder'
                    },
                    {
                        type: 'group',
                        id: 'scrapReworkQty',
                        fields: [
                            {
                                type: 'number',
                                id: 'scrapQty',
                                label: 'manufacturing.qualityCheck.form.scrapQty',
                                placeholder: '0',
                                decimals: 2,
                                defaultType: 'value',
                                defaultValue: 0,
                                variant: 'quantity'
                            },
                            {
                                type: 'number',
                                id: 'reworkQty',
                                label: 'manufacturing.qualityCheck.form.reworkQty',
                                placeholder: '0',
                                decimals: 2,
                                defaultType: 'value',
                                defaultValue: 0,
                                variant: 'quantity'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'defectCategory',
                        label: 'manufacturing.qualityCheck.form.defectCategory',
                        placeholder: 'manufacturing.qualityCheck.form.defectCategory.placeholder'
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'manufacturing.qualityCheck.form.notes',
                        placeholder: 'manufacturing.qualityCheck.form.notes.placeholder',
                        rows: 3
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'qualityCheckCard.qualityCheck.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'date',
                    columns: [
                        {
                            weight: 1,
                            basis: '30%',
                            elements: [
                                { type: 'field', value: 'resultName', scale: 'title' },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '70%',
                            elements: [
                                { type: 'field', value: 'workOrderNumber', scale: 'normal' },
                                { type: 'field', value: 'productName', scale: 'normal' },
                                { type: 'field', value: 'inspectorName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    shiftCard: {
        entity: 'shift',
        path: 'shift',
        titleBar: { mergeParams: ['code'], new: 'manufacturing.shift.form.new.title' },
        cardTitle: {
            title: 'manufacturing.shift.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.shift.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'shiftConfirmDelete'
                }
            ]
        },
        width: '756px',
        sections: [
            {
                id: 'shift',
                meta: {
                    type: 'form',
                    width: '480px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'codeName',
                        fields: [
                            {
                                type: 'text',
                                id: 'code',
                                label: 'manufacturing.shift.form.code',
                                placeholder: 'manufacturing.shift.form.code.placeholder',
                                required: true
                            },
                            {
                                type: 'text',
                                id: 'name',
                                label: 'manufacturing.shift.form.name',
                                placeholder: 'manufacturing.shift.form.name.placeholder',
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'weekday',
                        id: 'activeDays',
                        label: 'manufacturing.shift.form.activeDays'
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'shiftCard.shift.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'field', value: 'code', scale: 'title' },
                                { type: 'field', value: 'name', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'shift.shiftSlots',
                meta: {
                    type: 'lines',
                    linesArray: 'shiftSlots',
                    linesAddAction: 'manufacturing.shift.form.slots.add',
                    width: '480px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'startTimeDuration',
                        fields: [
                            {
                                type: 'text',
                                id: 'startTime',
                                label: 'manufacturing.shift.form.slot.startTime',
                                placeholder: 'manufacturing.shift.form.slot.startTime.placeholder',
                                required: true
                            },
                            {
                                type: 'number',
                                id: 'duration',
                                label: 'manufacturing.shift.form.slot.duration',
                                placeholder: 'manufacturing.shift.form.slot.duration.placeholder',
                                required: true,
                                decimals: 1,
                                defaultType: 'value',
                                defaultValue: 8,
                                variant: 'quantity'
                            }
                        ]
                    }
                ],
                buttons: [
                    { type: 'button', id: 'shiftCard.shiftSlots.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                    { type: 'button', id: 'shiftCard.shiftSlots.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'startTime',
                    emptyMessage: 'manufacturing.shift.form.slots.empty',
                    editButtonRightOffset: '40%',
                    columns: [
                        {
                            weight: 2, basis: '50%',
                            elements: [
                                { type: 'field', value: 'startTime', scale: 'title' }
                            ]
                        },
                        {
                            weight: 2, basis: '50%',
                            elements: [
                                { type: 'merge', value: '${1}h', mergeParams: ['duration'], scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    workCapabilityCard: {
        entity: 'workCapability',
        path: 'workCapability',
        titleBar: { mergeParams: ['name'], new: 'workCapability.form.new.title' },
        cardTitle: {
            title: 'workCapability.form.dropdown.toggle',
            menuItems: [
                { action: 'delete', label: 'workCapability.form.delete', confirm: true, modalConfig: 'workCapabilityConfirmDelete' }
            ]
        },
        sections: [{
            id: 'workCapability',
            meta: { type: 'form', width: '500px' },
            groups: [
                { type: 'text', id: 'name', label: 'workCapability.form.name', required: true },
                { type: 'text', id: 'code', label: 'workCapability.form.code', required: true },
                { type: 'text', id: 'description', label: 'workCapability.form.description' },
                {
                    type: 'switchSelect',
                    id: 'schedulingMode',
                    displayField: 'schedulingModeName',
                    label: 'workCapability.form.schedulingMode',
                    entity: 'schedulingMode',
                    valueMap: { 'schedulingMode': 'id', 'schedulingModeName': 'name' },
                    required: true,
                },
                { type: 'number', id: 'defaultSetupTime', label: 'workCapability.form.defaultSetupTime', decimals: 0, variant: 'quantity' },
                { type: 'number', id: 'defaultRunRate', label: 'workCapability.form.defaultRunRate', decimals: 2, variant: 'quantity' },
                { type: 'switch', id: 'isActive', label: 'workCapability.form.isActive' }
            ],
            buttons: [{ type: 'submit', id: 'workCapabilityCard.workCapability.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }]
        }]
    },

    workCenterCard: {
        entity: 'workCenter',
        path: 'workCenter',
        titleBar: { mergeParams: ['name'], new: 'manufacturing.workCenter.form.new.title' },
        cardTitle: {
            title: 'manufacturing.workCenter.form.dropdown.toggle',
            width: '1024px',
            buttons: [
                {
                    type: 'submit',
                    id: 'workCenterCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'createRack',
                    actionType: 'post',
                    // Create a CUSTOM footprint rack for this work center and link it
                    // (28.06 D2). Server-side via the createRack rule; no-op if already
                    // mapped. Posts to /workCenter/:id/createRack.
                    label: 'manufacturing.workCenter.form.dropdown.createRack'
                },
                {
                    action: 'delete',
                    label: 'manufacturing.workCenter.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ],
            // Success-toast titles + behaviour for post actions (read by postActionFn).
            // reload: refresh the work-center form in place instead of navigating away.
            actions: {
                createRack: { message: 'manufacturing.workCenter.createRack.complete', reload: true }
            }
        },
        sections: [
            {
                id: 'workCenter',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'nameCode',
                        name: 'nameCode',
                        fields: [
                            {
                                type: 'text',
                                id: 'name',
                                label: 'manufacturing.workCenter.form.name',
                                placeholder: 'manufacturing.workCenter.form.name.placeholder',
                                required: true
                            },
                            {
                                type: 'code',
                                id: 'code',
                                label: 'manufacturing.workCenter.form.code',
                                placeholder: 'manufacturing.workCenter.form.code.placeholder',
                                required: true,
                                maxLen: 5
                                // Freely editable since 28.06 Phase C — the code is a
                                // label, not an identity (the rack owns identity).
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'manufacturing.workCenter.form.description',
                        placeholder: 'manufacturing.workCenter.form.description.placeholder',
                        rows: 3
                    },
                    {
                        type: 'group',
                        id: 'warehousePlantId',
                        name: 'warehousePlant',
                        fields: [
                            {
                                type: 'dualconnect',
                                id: 'warehouseId',
                                displayField: 'warehouseName',
                                label: 'manufacturing.workCenter.form.warehouse',
                                placeholder: 'manufacturing.workCenter.form.warehouse.placeholder',
                                modalTitle: 'manufacturing.workCenter.form.warehouse.modal.title',
                                entity: 'warehouse',
                                valueMap: {
                                    'warehouseName': 'name',
                                    'warehouseId': 'id',
                                    'warehouseCode': 'code',
                                    'useHalls': 'useHalls'
                                },
                                options: { withHeaders: false },
                                showSubField: { field: 'useHalls', value: true },
                                sub: {
                                    id: 'hallId',
                                    displayField: 'hallName',
                                    placeholder: 'manufacturing.workCenter.form.hall.placeholder',
                                    modalTitle: 'manufacturing.workCenter.form.hall.modal.title',
                                    entity: 'hall',
                                    valueMap: {
                                        'hallName': 'name',
                                        'hallId': 'id',
                                        'hallCode': 'code'
                                    }
                                }
                            },
                            {
                                type: 'connect',
                                id: 'plantId',
                                displayField: 'plantName',
                                label: 'manufacturing.workCenter.form.plant',
                                placeholder: 'manufacturing.workCenter.form.plant.placeholder',
                                modalTitle: 'manufacturing.workCenter.form.plant.modal.title',
                                entity: 'plant',
                                valueMap: {
                                    'plantId': 'id',
                                    'plantName': 'name',
                                    'plantCode': 'code'
                                },
                                options: { withHeaders: true }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'workCapabilityDepartmentId',
                        name: 'capabilityDepartment',
                        fields: [
                            {
                                type: 'connect',
                                id: 'workCapabilityId',
                                displayField: 'workCapabilityName',
                                label: 'workCenter.form.workCapability',
                                modalTitle: 'manufacturing.workCenter.form.workCapability.modal.title',
                                entity: 'workCapability',
                                valueMap: {
                                    'workCapabilityId': 'id',
                                    'workCapabilityName': 'name',
                                    'workCapabilityCode': 'code'
                                },
                                options: { withHeaders: true }
                            },
                            {
                                type: 'connect',
                                id: 'workDepartmentId',
                                displayField: 'workDepartmentName',
                                label: 'manufacturing.workCenter.form.workDepartment',
                                modalTitle: 'manufacturing.workCenter.form.workDepartment.modal.title',
                                entity: 'workDepartment',
                                valueMap: {
                                    'workDepartmentId': 'id',
                                    'workDepartmentName': 'name',
                                    'workDepartmentCode': 'code'
                                },
                                options: { withHeaders: true }
                            }
                        ]
                    },
                    {
                        // Footprint rack mapping (28.06 Phase B / E1). Link the work
                        // center to a CUSTOM rack whose drawn positions become its
                        // routing stops. When set, the legacy hasLocations generation
                        // is skipped — the mapping supersedes it.
                        type: 'connect',
                        id: 'rackId',
                        displayField: 'rackCode',
                        label: 'manufacturing.workCenter.form.rack',
                        placeholder: 'manufacturing.workCenter.form.rack.placeholder',
                        modalTitle: 'manufacturing.workCenter.form.rack.modal.title',
                        entity: 'rack',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'kind', value: 'CUSTOM' }]
                        },
                        valueMap: { 'rackId': 'id', 'rackCode': 'code' },
                        options: { withHeaders: true }
                    },
                    {
                        // Capacity + Efficiency Factor on one line, below Footprint Rack.
                        type: 'group',
                        id: 'capacityEfficiencyFactor',
                        name: 'capacityEfficiency',
                        fields: [
                            {
                                type: 'number',
                                id: 'capacity',
                                label: 'manufacturing.workCenter.form.capacity',
                                placeholder: 'manufacturing.workCenter.form.capacity.placeholder',
                                decimals: 0,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'number',
                                id: 'efficiencyFactor',
                                label: 'workCenter.form.efficiencyFactor',
                                decimals: 2,
                                variant: 'quantity'
                            }
                        ]
                    },
                    {
                        // hasLocations retired in 28.06 Phase C (WP-11) — positions
                        // live on the mapped rack now, not generated from the work center.
                        type: 'switch',
                        id: 'active',
                        switchText: 'manufacturing.workCenter.form.active'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '40%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'field', value: 'code', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '60%',
                            elements: [
                                { type: 'field', value: 'description', scale: 'normal' },
                                { type: 'field', value: 'capacity', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    workDepartmentCard: {
        entity: 'workDepartment',
        path: 'workDepartment',
        titleBar: { mergeParams: ['name'], new: 'manufacturing.workDepartment.form.new.title' },
        cardTitle: {
            title: 'manufacturing.workDepartment.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.workDepartment.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'workDepartmentConfirmDelete'
                }
            ]
        },
        width: '756px',
        sections: [
            {
                id: 'workDepartment',
                meta: {
                    type: 'form',
                    width: '500px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'nameCode',
                        fields: [
                            {
                                type: 'text',
                                id: 'name',
                                label: 'manufacturing.workDepartment.form.name',
                                placeholder: 'manufacturing.workDepartment.form.name.placeholder',
                                required: true
                            },
                            {
                                type: 'code',
                                id: 'code',
                                label: 'manufacturing.workDepartment.form.code',
                                placeholder: 'manufacturing.workDepartment.form.code.placeholder',
                                required: true,
                                maxLen: 10
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'manufacturing.workDepartment.form.description',
                        placeholder: 'manufacturing.workDepartment.form.description.placeholder',
                        rows: 2
                    },
                    {
                        type: 'connect',
                        id: 'plantId',
                        displayField: 'plantName',
                        label: 'manufacturing.workDepartment.form.plant',
                        placeholder: 'manufacturing.workDepartment.form.plant.placeholder',
                        modalTitle: 'manufacturing.workDepartment.form.plant.modal.title',
                        entity: 'plant',
                        valueMap: {
                            'plantId': 'id',
                            'plantName': 'name',
                            'plantCode': 'code'
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'description',
                        id: 'shiftOverride',
                        label: 'manufacturing.workDepartment.form.shift.title',
                        text: 'manufacturing.workDepartment.form.shift.description'
                    },
                    {
                        type: 'connect',
                        id: 'shiftId',
                        displayField: 'shiftName',
                        label: 'manufacturing.workDepartment.form.shift',
                        placeholder: 'manufacturing.workDepartment.form.shift.placeholder',
                        modalTitle: 'manufacturing.workDepartment.form.shift.modal.title',
                        entity: 'shift',
                        valueMap: {
                            'shiftId': 'id',
                            'shiftName': 'name',
                            'shiftCode': 'code'
                        },
                        options: { withHeaders: true }
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'workDepartmentCard.workDepartment.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '60%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'field', value: 'plantName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '40%',
                            align: 'end',
                            elements: [
                                { type: 'field', value: 'shiftName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    workOperationCard: {
        entity: 'workOperation',
        path: 'workOperation',
        titleBar: { mergeParams: ['name'], new: 'workOperation.form.new.title' },
        cardTitle: {
            title: 'workOperation.form.dropdown.toggle',
            buttons: [
                { type: 'submit', id: 'workOperationCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary', confirm: false }
            ],
            menuItems: [
                { action: 'delete', label: 'workOperation.form.dropdown.delete', confirm: true, modalConfig: 'confirmDelete' }
            ]
        },
        fieldsLogic: ['setupTime', 'runTimePerUnit', 'queueTime', 'moveTime'],
        sections: [
            {
                id: 'workOperation.details',
                meta: { type: 'form', width: '800px' },
                groups: [
                    {
                        type: 'group',
                        id: 'sequenceName',
                        fields: [
                            { type: 'number', id: 'sequence', label: 'workOperation.form.sequence', placeholder: '0', required: true, decimals: 0, variant: 'quantity' },
                            { type: 'text', id: 'name', label: 'workOperation.form.name', placeholder: 'workOperation.form.name.placeholder', required: true }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'workCapabilityCenterId',
                        fields: [
                            {
                                type: 'connect',
                                id: 'workCapabilityId',
                                displayField: 'workCapabilityName',
                                label: 'workOperation.form.workCapability',
                                modalTitle: 'workOperation.form.workCapability.modal.title',
                                entity: 'workCapability',
                                valueMap: { 'workCapabilityId': 'id', 'workCapabilityName': 'name' },
                                required: true,
                                manualEntry: false
                            },
                            {
                                type: 'connect',
                                id: 'workCenterId',
                                displayField: 'workCenterName',
                                label: 'workOperation.form.workCenter',
                                modalTitle: 'workOperation.form.workCenter.modal.title',
                                entity: 'workCenter',
                                valueMap: { 'workCenterId': 'id', 'workCenterName': 'name' },
                                manualEntry: false
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'plannedStartEnd',
                        fields: [
                            { type: 'datetime', id: 'plannedStart', label: 'workOperation.form.plannedStart' },
                            { type: 'datetime', id: 'plannedEnd', label: 'workOperation.form.plannedEnd' }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'plannedQty',
                        fields: [
                            { type: 'text-readOnly', id: 'plannedQty', label: 'workOperation.form.plannedQty' },
                            {
                                type: 'modal',
                                control: {
                                    type: 'text',
                                    id: 'timeModal',
                                    label: 'workOperation.form.totalTime',
                                    placeholder: 'workOperation.form.time.placeholder'
                                },
                                descriptions: [
                                    { type: 'field', field: 'totalTime' },
                                    { type: 'text', text: 'manufacturing.workOperation.form.minutes.suffix' }
                                ],
                                modalForm: {
                                    id: 'workOperationTime',
                                    elements: [
                                        {
                                            type: 'number',
                                            id: 'setupTime',
                                            label: 'workOperation.form.setupTime',
                                            placeholder: '0',
                                            decimals: 2,
                                            linkedFields: ['setupTime', 'runTimePerUnit', 'queueTime', 'moveTime', 'plannedQty'],
                                            variant: 'quantity'
                                        },
                                        {
                                            type: 'number',
                                            id: 'runTimePerUnit',
                                            label: 'workOperation.form.runTimePerUnit',
                                            placeholder: '0',
                                            decimals: 2,
                                            linkedFields: ['setupTime', 'runTimePerUnit', 'queueTime', 'moveTime', 'plannedQty'],
                                            variant: 'quantity'
                                        },
                                        {
                                            type: 'number',
                                            id: 'queueTime',
                                            label: 'workOperation.form.queueTime',
                                            placeholder: '0',
                                            decimals: 2,
                                            linkedFields: ['setupTime', 'runTimePerUnit', 'queueTime', 'moveTime', 'plannedQty'],
                                            variant: 'quantity'
                                        },
                                        {
                                            type: 'number',
                                            id: 'moveTime',
                                            label: 'workOperation.form.moveTime',
                                            placeholder: '0',
                                            decimals: 2,
                                            linkedFields: ['setupTime', 'runTimePerUnit', 'queueTime', 'moveTime', 'plannedQty'],
                                            variant: 'quantity'
                                        },
                                        {
                                            type: 'text-readOnly',
                                            id: 'totalTime',
                                            label: 'workOperation.form.totalTime'
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    { type: 'textarea', id: 'notes', label: 'workOperation.form.notes', placeholder: 'workOperation.form.notes.placeholder', rows: 3 }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '35%',
                            elements: [
                                { type: 'field', value: 'name', scale: 'title' },
                                { type: 'field', value: 'workCapabilityName', scale: 'normal' },
                                { type: 'field', value: 'productName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '40%',
                            elements: [
                                { type: 'field', value: 'workCenterName', scale: 'normal' },
                                { type: 'datetime', value: 'plannedStart', scale: 'normal' },
                                { type: 'datetime', value: 'plannedEnd', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '25%',
                            align: 'end',
                            elements: [
                                { type: 'field', value: 'stateName', scale: 'normal' },
                                { type: 'merge', value: '${1} / ${2}', mergeParams: ['completedQty', 'plannedQty'], scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'workOperation.plannedInputs',
                meta: {
                    type: 'lines',
                    linesArray: 'plannedInputs',
                    displayOnly: true,
                    condition: { field: 'plannedInputs', operator: 'minLength', value: 1 },
                    width: '800px'
                },
                displaySection: {
                    emptyField: 'productName',
                    columns: [
                        { weight: 3, basis: '60%', elements: [{ type: 'field', value: 'productName', scale: 'title' }] },
                        { weight: 2, basis: '40%', elements: [{ type: 'merge', value: '${1} ${2}', mergeParams: ['qty', 'uomName'], scale: 'normal' }] }
                    ]
                }
            },
            {
                id: 'workOperation.plannedOutputs',
                meta: {
                    type: 'lines',
                    linesArray: 'plannedOutputs',
                    displayOnly: true,
                    condition: { field: 'plannedOutputs', operator: 'minLength', value: 1 },
                    width: '800px'
                },
                displaySection: {
                    emptyField: 'productName',
                    columns: [
                        { weight: 3, basis: '60%', elements: [{ type: 'field', value: 'productName', scale: 'title' }] },
                        { weight: 2, basis: '40%', elements: [{ type: 'merge', value: '${1} ${2}', mergeParams: ['qty', 'uomName'], scale: 'normal' }] }
                    ]
                }
            },
            {
                id: 'workOperation.documents',
                meta: {
                    type: 'lines',
                    linesArray: 'documents',
                    sectionTitle: 'workOperation.form.documents',
                    displayOnly: true,
                    condition: { field: 'documents', operator: 'minLength', value: 1 },
                    width: '800px'
                },
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        { weight: 3, basis: '70%', elements: [{ type: 'field', value: 'name', scale: 'title' }] },
                        { weight: 1, basis: '30%', elements: [{ type: 'field', value: 'fileTypeName', scale: 'normal' }] }
                    ]
                }
            }
        ]
    },

    workOperationConsumptionCard: {
        entity: 'workOperationConsumption',
        path: 'workOperation/:id/workOperationConsumption',
        titleBar: { mergeParams: ['productName'], new: 'workExecution.modal.consumption.title' },
        sections: [{
            id: 'workOperationConsumption',
            meta: { type: 'form', width: '400px' },
            groups: [
                { type: 'number', id: 'consumedQty', label: 'workExecution.modal.consumption.qty', required: true, variant: 'quantity' },
                {
                    type: 'select',
                    id: 'type',
                    displayField: 'typeName',
                    label: 'workExecution.modal.consumption.type',
                    entity: 'workOperationConsumptionType',
                    valueMap: { 'type': 'id', 'typeName': 'name' },
                    options: { withHeaders: false },
                },
                { type: 'textarea', id: 'notes', label: 'workExecution.modal.consumption.notes', rows: 2 }
            ],
            buttons: [{ type: 'submit', id: 'workOperationConsumptionCard.workOperationConsumption.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary' }]
        }]
    },

    workOperationExecutionCard: {
        entity: 'workOperation',
        path: 'workOperation',
        titleBar: { mergeParams: ['name'], new: null },   // never opened in 'new' mode,
        fieldsLogic: [],
        sections: [{
            id: 'workOperation',
            meta: { type: 'form', width: '100%' },
            groups: [
                { type: 'text-readOnly', id: 'workOrderNumber', label: 'workExecution.card.workOrder' },
                { type: 'text-readOnly', id: 'productName', label: 'workExecution.card.product' },
                { type: 'text-readOnly', id: 'stateName', label: 'workExecution.card.status' },
                {
                    type: 'group',
                    id: 'plannedCompletedRejectedQty',
                    fields: [
                        { type: 'text-readOnly', id: 'plannedQty', label: 'workExecution.card.plannedQty', displayType: 'quantity' },
                        { type: 'text-readOnly', id: 'completedQty', label: 'workExecution.card.completedQty', displayType: 'quantity' },
                        { type: 'text-readOnly', id: 'rejectedQty', label: 'workExecution.card.rejectedQty', displayType: 'quantity' }
                    ]
                }
            ],
            displayButtons: {
                start: { label: 'workExecution.button.start', action: 'start', condition: { field: '$state', operator: 'in', value: ['scheduled'] }, variant: 'primary' },
                pause: { label: 'workExecution.button.pause', action: 'pause', condition: { field: '$state', operator: 'in', value: ['inProgress'] }, variant: 'warning', confirm: true, modalConfig: 'workOperationConfirmPause' },
                resume: { label: 'workExecution.button.resume', action: 'resume', condition: { field: '$state', operator: 'in', value: ['paused'] }, variant: 'primary' },
                complete: { label: 'workExecution.button.complete', action: 'complete', condition: { field: '$state', operator: 'in', value: ['inProgress'] }, variant: 'success', confirm: true, modalConfig: 'workOperationConfirmComplete' },
                stop: { label: 'workExecution.button.stop', action: 'stop', condition: { field: '$state', operator: 'in', value: ['inProgress', 'paused'] }, variant: 'danger', confirm: true, modalConfig: 'workOperationConfirmStop' },
                registerOutput: { label: 'workExecution.button.registerOutput', action: 'modal', condition: { field: '$state', operator: 'in', value: ['inProgress', 'paused'] }, modalConfig: 'workOperationRegisterOutput' }
            },
            displaySection: {
                emptyField: 'name',
                columns: [
                    {
                        weight: 1,
                        basis: '40%',
                        elements: [
                            { type: 'field', value: 'name', scale: 'title' },
                            { type: 'field', value: 'workOrderNumber', scale: 'normal' },
                            { type: 'field', value: 'productName', scale: 'normal' }
                        ]
                    },
                    {
                        weight: 1,
                        basis: '35%',
                        elements: [
                            { type: 'field', value: 'workCenterName', scale: 'normal' },
                            { type: 'field', value: 'stateName', scale: 'normal' }
                        ]
                    },
                    {
                        weight: 1,
                        basis: '25%',
                        align: 'end',
                        elements: [
                            { type: 'merge', value: '${1} / ${2}', mergeParams: ['completedQty', 'plannedQty'], scale: 'normal' }
                        ]
                    }
                ]
            }
        }]
    },

    workOperationOutputCard: {
        entity: 'workOperationOutput',
        path: 'workOperation/:id/workOperationOutput',
        titleBar: { mergeParams: ['productName'], new: 'workExecution.modal.output.title' },
        width: '100%',
        showBack: false,
        afterSubmit: { stay: true },
        sections: [{
            id: 'workOperationOutput',
            meta: { type: 'form', width: '100%' },
            groups: [
                { type: 'number', id: 'goodQty', label: 'workExecution.modal.output.goodQty', required: true, variant: 'quantity' },
                { type: 'number', id: 'rejectedQty', label: 'workExecution.modal.output.rejectedQty', variant: 'quantity' },

                { type: 'textarea', id: 'notes', label: 'workExecution.modal.output.notes', rows: 2 }
            ],
            buttons: [{ type: 'submit', id: 'workOperationOutputCard.workOperationOutput.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'name',
                columns: [
                    {
                        weight: 1,
                        basis: '40%',
                        elements: [
                            { type: 'field', value: 'goodQty', scale: 'title' },
                            { type: 'field', value: 'productName', scale: 'normal' },
                        ]
                    },
                    {
                        weight: 1,
                        basis: '35%',
                        elements: [
                            { type: 'field', value: 'notes', scale: 'normal' },
                        ]
                    }
                ]
            }
        }]
    },

    workOrderCard: {
        entity: 'workOrder',
        path: 'workOrder',
        titleBar: { mergeParams: ['number'], new: 'manufacturing.workOrder.form.new.title' },
        cardTitle: {
            title: 'manufacturing.workOrder.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'workOrderCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'manufacturing.workOrder.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'confirmBook',
                    modalPreflight: 'preBook'
                },
                {
                    action: 'createOperations',
                    label: 'manufacturing.workOrder.form.createOperations',
                    confirm: false
                }
            ]
        },
        sections: [
            {
                id: 'workOrder.header',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberPriority',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'manufacturing.workOrder.form.number',
                                placeholder: 'manufacturing.workOrder.form.number.placeholder',
                                entity: 'workOrder',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'switchSelect',
                                id: 'priority',
                                displayField: 'priorityName',
                                label: 'manufacturing.workOrder.form.priority',
                                entity: 'workPriority',
                                valueMap: {
                                    'priority': 'id',
                                    'priorityName': 'name'
                                },
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'startEndTime',
                        fields: [
                            {
                                type: 'datetime',
                                id: 'startTime',
                                label: 'manufacturing.workOrder.form.startDate',
                                readOnly: true
                            },
                            {
                                type: 'datetime',
                                id: 'endTime',
                                label: 'manufacturing.workOrder.form.endDate',
                                readOnly: true
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'plantId',
                        displayField: 'plantName',
                        label: 'manufacturing.workOrder.form.plant',
                        placeholder: 'manufacturing.workOrder.form.plant.placeholder',
                        modalTitle: 'manufacturing.workOrder.form.plant.modal.title',
                        entity: 'plant',
                        valueMap: {
                            'plantId': 'id',
                            'plantName': 'name',
                            'plantCode': 'code'
                        },
                        options: { withHeaders: false }
                    },
                    {
                        type: 'connect',
                        id: 'productId',
                        displayField: 'productName',
                        label: 'manufacturing.workOrder.form.product',
                        placeholder: 'manufacturing.workOrder.form.product.placeholder',
                        modalTitle: 'manufacturing.workOrder.form.product.modal.title',
                        entity: 'product',
                        entityParams: {
                            type: 'filter',
                            filters: [{ key: 'type', value: 'manufactured' }]
                        },
                        valueMap: {
                            'productName': 'name',
                            'productId': 'id',
                            'unitId': 'unitId',
                            'unitName': 'unitName'
                        },
                        options: { withHeaders: false },
                        required: true
                    },
                    {
                        type: 'connect',
                        id: 'routingVersionId',
                        displayField: 'routingVersionName',
                        label: 'workOrder.form.routingVersion',
                        modalTitle: 'workOrder.form.routingVersion.modal.title',
                        entity: 'routingVersion',
                        entityParams: {
                            type: 'filter',
                            filters: [
                                { key: 'status', value: 'active' },
                                { key: 'productId', value: '${productId}' }
                            ]
                        },
                        valueMap: {
                            'routingVersionId': 'id',
                            'routingVersionName': 'name'
                        },
                        options: { withHeaders: true },
                        linkedFields: ['productId']
                    },
                    {
                        type: 'group',
                        id: 'plannedQtyUnitId',
                        fields: [
                            {
                                type: 'number',
                                id: 'plannedQty',
                                label: 'manufacturing.workOrder.form.plannedQty',
                                placeholder: '0',
                                required: true,
                                decimals: 2,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'manufacturing.workOrder.form.unit',
                                placeholder: 'manufacturing.workOrder.form.unit.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true }
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'notes',
                        label: 'manufacturing.workOrder.form.notes',
                        placeholder: 'manufacturing.workOrder.form.notes.placeholder',
                        rows: 3
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    columns: [
                        {
                            weight: 1,
                            basis: '30%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'date', value: 'startTime', scale: 'normal' },
                                { type: 'field', value: 'state', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 2,
                            basis: '70%',
                            elements: [
                                { type: 'field', value: 'productName', scale: 'normal' },
                                { type: 'field', value: 'workCenterName', scale: 'normal' },
                                { type: 'field', value: 'plannedQty', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },
}
